const __WEBPACK_NAMESPACE_OBJECT__ = require("core-js/proposals/explicit-resource-management");